module.exports = __webpack_public_path__ + "static/media/18Demo Photo-ink.8ea8ac7f.jpeg";